import styled from 'styled-components';
import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { MobileBtnWrap, MobileBtn } from '.';
import { Link } from '../../routes';

const PX2VW = 100 / 375;

// eslint-disable-next-line semi
const px2vw = (num: number): string => `${num * PX2VW}vw`;

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: ${px2vw(76)};
`;

const Line = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: ${px2vw(16)};
  margin-left: ${px2vw(16)};
  margin-right: ${px2vw(16)};
  width: ${px2vw(343)};
  height: ${px2vw(1)};
  background: #eaecef;
`;

const Title = styled.div`
  width: 100%;
  display: flex;
  font-weight: 600;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: ${px2vw(8)};
  padding-top: ${px2vw(25)};

  > span {
    width: ${px2vw(375)};
    padding-left: ${px2vw(30)};
    font-family: ${({ theme }) => theme.fontIBMMedium};
    font-size: ${px2vw(32)};
    line-height: ${px2vw(45)};
    color: '#000';
  }
`;

const TipsItem = styled.div`
  margin-bottom: ${px2vw(16)};
  > div {
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-size: ${px2vw(16)};
    line-height: ${px2vw(22)};
    color: #212833;
    width: ${px2vw(343)};
    display: flex;
    flex-direction: row;
    justify-content: center;

    div:first-child {
      text-align: center;
      width: ${px2vw(22)};
      height: ${px2vw(22)};
      background-repeat: no-repeat;
      background-image: url(${require('./newImage/indexBackground.svg')});
      background-size: ${px2vw(22)} ${px2vw(22)};
      background-position: top left;
      margin-right: ${px2vw(8)};
    }

    div:last-child {
      width: ${px2vw(283)};
    }

    div:last-child {
      width: ${px2vw(313)};
    }
  }
`;

const _toUrl = (url: string) => {
  window.location.href = url;
};

const Download = ({ locale }) => (
  <>
    <Head>
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,user-scalable=no"
      />
    </Head>
    <Link route={`/${locale}/download`}>
      <img
        style={{
          width: px2vw(30),
          height: px2vw(30),
          paddingLeft: px2vw(4),
          paddingTop: px2vw(7),
        }}
        alt="phone"
        title="phone"
        src={require('./newImage/leftArrow.svg')}
      />
    </Link>
    <Title>
      <span>如何切换苹果ID</span>
    </Title>
    <Box>
      <Line />
      <TipsItem>
        <div>
          <div>1</div>
          <div>第一步，点击App Store首页右上角头像</div>
        </div>
      </TipsItem>
      <TipsItem>
        <img
          style={{ width: px2vw(295), height: px2vw(240) }}
          alt="phone"
          title="phone"
          src={require('./newImage/step1.png')}
        />
      </TipsItem>
      <Line />
      <TipsItem>
        <div>
          <div>2</div>
          <div>
            第二步，点击退出登录，重新输入Apple
            ID及密码。如果您没有苹果海外ID（建议香港ID），您可至淘宝搜索“苹果香港ID”购买
          </div>
        </div>
      </TipsItem>
      <TipsItem>
        <img
          style={{ width: px2vw(295), height: px2vw(493.49) }}
          alt="phone"
          title="phone"
          src={require('./newImage/step2.png')}
        />
      </TipsItem>
      <Line />
      <TipsItem>
        <div>
          <div>3</div>
          <div>第三步，输入非大陆苹果账号</div>
        </div>
      </TipsItem>
      <TipsItem>
        <img
          style={{ width: px2vw(295), height: px2vw(235.7) }}
          alt="phone"
          title="phone"
          src={require('./newImage/step3.png')}
        />
      </TipsItem>
      <Line />
      <TipsItem>
        <div>
          <div>4</div>
          <div>第四步，搜索Binance App。</div>
        </div>
      </TipsItem>
      <TipsItem>
        <img
          style={{ width: px2vw(295), height: px2vw(322.41) }}
          alt="phone"
          title="phone"
          src={require('./newImage/step4.png')}
        />
      </TipsItem>
    </Box>
    <MobileBtnWrap>
      <MobileBtn
        isApple={true}
        onClick={() => _toUrl('https://apps.apple.com/hk/app/binance/id1436799971?l=en')}
      >
        <div>
          <strong>我已了解，继续下载</strong>
        </div>
      </MobileBtn>
    </MobileBtnWrap>
  </>
);

Download.propTypes = {
  locale: PropTypes.string,
};

export default Download;
